import { TaskLanguageSelect, TaskSetup } from '@/features/contribution-kit';
import { ValidationGateProgressStrip } from '@/features/validation-gate';
import { TranscriptionSourcePicker } from '@/components/contribute/TranscriptionSourcePicker';
import type { TranscriptionSource } from '@/lib/transcription-source';
import type { ValidateTranscriptionCopy } from './validate-transcription-copy';

type ValidateTranscriptionSetupProps = {
  t: Record<string, unknown>;
  copy: ValidateTranscriptionCopy;
  languages: Array<{ code: string; name: string; displayName?: string }>;
  selectedLanguage: string;
  onLanguageChange: (code: string) => void;
  source: TranscriptionSource;
  onSourceChange: (source: TranscriptionSource) => void;
  canStart: boolean;
  isLoading: boolean;
  onStart: () => void;
  onBack: () => void;
};

/** Before a "Valider des textes" session: language, source, rules, load the batch. */
export function ValidateTranscriptionSetup({
  t,
  copy,
  languages,
  selectedLanguage,
  onLanguageChange,
  source,
  onSourceChange,
  canStart,
  isLoading,
  onStart,
  onBack,
}: ValidateTranscriptionSetupProps) {
  const s = (key: string) => String(t[key] ?? '');
  return (
    <TaskSetup
      task="verifyText"
      title={s('validateTranscriptions')}
      description={s('validateTranscriptionsDescription')}
      instructions={[...copy.instructions]}
      notices={<ValidationGateProgressStrip />}
      startLabel={s('startValidation')}
      onStart={onStart}
      startDisabled={!canStart}
      starting={isLoading}
      onBack={onBack}
    >
      <div className="space-y-2">
        <label htmlFor="validate-transcription-language" className="text-sm font-medium text-foreground">
          {s('selectLanguage')}
        </label>
        <TaskLanguageSelect
          id="validate-transcription-language"
          value={selectedLanguage}
          onChange={onLanguageChange}
          languages={languages.map((language) => ({ ...language, flag: undefined }))}
          placeholder={s('selectLanguage')}
        />
      </div>
      <TranscriptionSourcePicker t={t} value={source} onChange={onSourceChange} />
    </TaskSetup>
  );
}
